import React, { useEffect } from 'react'
import { useMobileView } from '@/hooks'

const Alibaba_PuHuiTi_35_Thin =
  'https://heap-web.oss-cn-hangzhou.aliyuncs.com/fonts/Alibaba_PuHuiTi_2.0_35_Thin_35_Thin.woff2'
const Alibaba_PuHuiTi_55_Regular =
  'https://heap-web.oss-cn-hangzhou.aliyuncs.com/fonts/Alibaba_PuHuiTi_2.0_55_Regular_55_Regular.woff2'
const Alibaba_PuHuiTi_75_SemiBold =
  'https://heap-web.oss-cn-hangzhou.aliyuncs.com/fonts/Alibaba_PuHuiTi_2.0_75_SemiBold_75_SemiBold.woff2'

const FontProvider: React.FC<{ children: React.ReactElement }> = (props) => {
  const { children } = props
  const isMobile = useMobileView()

  useEffect(() => {
    if (!isMobile) {
      const AlibabaPuHuiTiRegular = new FontFace(
        'AlibabaPuHuiTiRegular',
        `url(${Alibaba_PuHuiTi_55_Regular}) format("woff2"), local("PingFang SC")`,
        {
          weight: '400',
          display: 'swap',
        }
      )
      const AlibabaPuHuiTiBold = new FontFace(
        'AlibabaPuHuiTiBold',
        `url(${Alibaba_PuHuiTi_75_SemiBold}) format("woff2"), local("PingFang SC")`,
        {
          weight: '600',
          display: 'swap',
        }
      )
      const AlibabaPuHuiTiThin = new FontFace(
        'AlibabaPuHuiTiThin',
        `url(${Alibaba_PuHuiTi_35_Thin}) format("woff2"), local("PingFang SC")`,
        {
          weight: '250',
          display: 'swap',
        }
      )
      if (!isMobile) {
        !document.fonts.has(AlibabaPuHuiTiRegular) &&
          document.fonts?.add(AlibabaPuHuiTiRegular)
        !document.fonts.has(AlibabaPuHuiTiBold) &&
          document.fonts?.add(AlibabaPuHuiTiBold)
        !document.fonts.has(AlibabaPuHuiTiThin) &&
          document.fonts?.add(AlibabaPuHuiTiThin)
      }
    }
  }, [isMobile])

  return children
}

export default FontProvider
